const langDocumentTypeSub = {
	quarterly_management_report: {
		tag: 'document.type_sub_sub.quarterly_management_report',
		fr: 'Rapport de Gestion Trimestriel',
		en: 'Quarterly management report',
	},
	signed_subscription_bulletin: {
		tag: 'document.type_sub.signed_subscription_bulletin',
		fr: 'Bulletins de souscription signés',
		en: 'Signed subscription bulletin',
	},
	prospectus: {
		tag: 'document.type_sub.prospectus',
		fr: 'Prospectus du fonds',
		en: 'Fund prospectus',
	},
	annual_management_report: {
		tag: 'document.type_sub.annual_management_report',
		fr: 'Rapport de Gestion Annuel',
		en: 'Annual management report',
	},
	valuation_methodology: {
		tag: 'document.type_sub.valuation_methodology',
		fr: 'Méthodologie Valorisation',
		en: 'Valuation methodology',
	},
	auditor_report: {
		tag: 'document.type_sub.auditor_report',
		fr: 'Rapport du CAC',
		en: 'Auditor report',
	},
	signed_subscription_contract: {
		tag: 'document.type_sub.signed_subscription_contract',
		fr: 'Contrats de souscription signés',
		en: 'Signed subscription contract',
	},
	share_certificate: {
		tag: 'document.type_sub.share_certificate',
		fr: 'Attestation de part',
		en: 'Share certificate',
	},
	monthly_management_report: {
		tag: 'document.type_sub.monthly_management_report',
		fr: 'Rapport de Gestion Mensuel',
		en: 'Monthly management report',
	},

	nav_sheet: {
		tag: 'document.type_sub.nav_sheet',
		fr: 'Fiche VL',
		en: 'NAV sheet',
	},
	capital_call: {
		tag: 'document.type_sub.capital_call',
		fr: 'Appel de fonds',
		en: 'Capital call',
	},
	ampere_report: {
		tag: 'document.type_sub.ampere_report',
		fr: 'Rapport AMPERE',
		en: 'AMPERE Report',
	},
	covid_19_information_notice: {
		tag: 'document.type_sub.covid_19_information_notice',
		fr: "Note d'information Covid-19",
		en: 'Covid-19 information notice',
	},
	consultation_minutes: {
		tag: 'document.type_sub.consultation_minutes',
		fr: 'PV de Consultation',
		en: 'Consultation minutes',
	},
	distribution_note: {
		tag: 'document.type_sub.distribution_note',
		fr: 'Notice de distribution',
		en: 'Distribution note',
	},
	key_information_document: {
		tag: 'document.type_sub.key_information_document',
		fr: "Documents d'informations clés pour l'investisseur",
		en: 'Key Information Document',
	},
	sfdrinternet_sheet: {
		tag: 'document.type_sub.sfdrinternet_sheet',
		fr: 'Fiche internet SFDR',
		en: 'SFDR internet form',
	},
	SFDR_precontractual_document: {
		tag: 'document.type_sub.SFDR_precontractual_document',
		fr: 'Annexe précontractuelle SFDR',
		en: 'SFDR Precontractual Document',
	},
	product_sheet: {
		tag: 'document.type_sub.product_sheet',
		fr: 'Fiche produit',
		en: 'Product form',
	},
	fund_sheet: {
		tag: 'document.type_sub.fund_sheet',
		fr: 'Fiche Fonds',
		en: 'Funds form',
	},
	inventory: {
		tag: 'document.type_sub.inventory',
		fr: 'Document Inventaire',
		en: 'Inventory document',
	},
};

export default langDocumentTypeSub;
